import apiUseCases from "@src/cloud-connect/api";
import { RolesDescriptions } from "@src/types/role-manager";

export interface GetRolesDescriptionsResult {
  success: boolean;
  data?: RolesDescriptions;
  error?: string;
}

export const getRolesDescriptions =
  async (): Promise<GetRolesDescriptionsResult> => {
    try {
      const response = await apiUseCases.getRolesDescriptions();

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : "Failed to fetch roles descriptions",
      };
    }
  };
